import ImageMarquee from '@/app/components/shared/Marquee';
import DynamicHero from '@/app/components/platform/DynamicHero';

const HeaderSlider = ({
  content,
  logo,
  showSwordLogo = true,
  userName,
  distanceToTop,
  barHeight,
  slider,
}) => {
  const images = content.slider ?? slider;

  return (
    <DynamicHero
      content={content?.content ?? content}
      logo={logo}
      showSwordLogo={showSwordLogo}
      userName={userName}
      distanceToTop={distanceToTop}
      barHeight={barHeight}
    >
      <ImageMarquee images={images} />
    </DynamicHero>
  );
};
HeaderSlider.defaultConfig = {
  rounded: true,
  colored: true,
  spaceBottom: false,
  spaceTop: false,
  marginBottom: true,
  withGradient: false,
  fullHeight: true,
};
export default HeaderSlider;
